// CursorSVG
function CursorSVG(props) {
  return (
    <svg
      viewBox="8 4 8 16"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor"
    >
      <rect x="10" y="6" width="4" height="12" fill="#353B40" />
    </svg>
  );
}

export default CursorSVG;
